import _ from "lodash";

export default val => (_.isNil(val) || !_.isString(val) ? val : val.toUpperCase());
